import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import formationsReseauxSociauxStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'formationsReseauxSociaux'
const customImplement: CustomStoreImplementationOptions = formationsReseauxSociauxStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function formationsReseauxSociauxFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('prog-08-reseaux-sociaux.title', 'Formation réseaux sociaux sur-mesure'),
        $description: $translate('prog-08-reseaux-sociaux.description', 'Maîtrisez les fonctionnalités et tendances des réseaux sociaux adaptés à votre entreprise grâce à une formation sur-mesure offerte par un expert Matchers !'),
        $publishedTime: new Date('2023-03-26T21:03:21.009Z'),
        $modifiedTime: new Date('2023-09-15T08:00:45.807Z'),
        // Constants,
        $constants: {
          blocPreviewProfilExpertTags: [
            { Nom: 'Copywriting' },
            { Nom: 'Storytelling' },
            { Nom: 'Animation site Internet' },
            { Nom: 'SEO/SEA' },
            { Nom: 'Community management' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element1Tags: [
            { Nom: 'Social media / Ads' },
            { Nom: 'Vidéo' },
            { Nom: 'TikTok' },
            { Nom: 'Stratégie de contenu' },
            { Nom: 'Instagram' },
            { Nom: 'Snapchat' },
            { Nom: 'YouTube' },
            { Nom: 'Pinterest' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element2Tags: [
            { Nom: 'Réseaux sociaux' },
            { Nom: 'Pub sponsorisée' },
            { Nom: 'Personal branding' },
            { Nom: 'LinkedIn' },
            { Nom: 'Social media' },
            { Nom: 'Stratégie digitale' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element3Tags: [
            { Nom: 'Communication visuelle' },
            { Nom: 'Design' },
            { Nom: 'Charte graphique' },
            { Nom: 'Illustrator' },
            { Nom: 'Design digital' },
            { Nom: 'Infographie' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          dropDownFormationArguments: [
            { Text: '<ul><li>Définir ses objectifs.</li></ul>' },
            { Text: '<ul><li>Appréhender le marché de la recherche en ligne.</li></ul>' },
            { Text: '<ul><li>Maîtriser les caractéristiques de chaque média, en particulier Facebook et Instagram.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element4Arguments: [
            { Text: '<ul><li>Déterminer sa stratégie de contenus.</li></ul>' },
            { Text: '<ul><li>Décliner son contenu pour l’adapter à sa cible.</li></ul>' },
            { Text: '<ul><li>Cartographier un plan d’actions.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element5Arguments: [
            { Text: '<ul><li>Appréhender le marché de la recherche en ligne.</li></ul>' },
            { Text: '<ul><li>Produire des visuels adaptés à chaque réseau social.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element6Arguments: [
            { Text: '<ul><li>Gérer son planning éditorial.</li></ul>' },
            { Text: '<ul><li>Tester les outils d’automatisation de publication.</li></ul>' },
            { Text: '<ul><li>Maîtriser les différents critères principaux des algorithmes.</li></ul>' },
            { Text: '<ul><li>Baser sa stratégie sur la récurrence.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          pFormationMatchingExpertText: '<p><strong>Anna </strong>| Cheffe de produit marketing</p><p>&nbsp;</p><p><strong>Expertise :&nbsp;</strong><span style="color:rgb(34,34,34);">Plusieurs années d’expertise</span> en marketing stratégique et opérationnel ainsi qu’en création d’identité et d’image de marques de luxe et moyenne / haut de gamme.<span style="color:rgb(34,34,34);">&nbsp;</span></p>'
        },
        // Data,
        $info: { prog08ReseauxSociaux: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      blocPreviewProfilExpertClick () {
        openUrl('https://www.matchers.fr/expert/457', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element1Click () {
        openUrl('https://www.matchers.fr/expert/266', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element2Click () {
        openUrl('https://www.matchers.fr/expert/194', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element3Click () {
        openUrl('https://www.matchers.fr/expert/274', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      voirClick () {
        openUrl('https://www.matchers.fr/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return formationsReseauxSociauxFactory(storeId)()
}

export const formationsReseauxSociauxRaw = formationsReseauxSociauxFactory()
export const formationsReseauxSociaux = () => formationsReseauxSociauxRaw() as MergeCustomStore<typeof formationsReseauxSociauxStoreCustom.instance>
